import { ComponentProps, ComponentType, createContext } from 'react';
import Dialog from '#shared/components/Dialog/Dialog';

// Props every component passed to open() receives. The component must render a <Dialog.Title> (Dialog from
// '#shared/components/Dialog/Dialog' inside shared, 'shared' in a host) — hidden if the design has no
// visible heading — so the dialog has an accessible name.
export type DialogComponentProps<ReturnType> = {
  onConfirm: (value: ReturnType) => void;
  onCancel: () => void;
};

// overlay, depthFromTop and onExited are DialogProvider's own plumbing for rendering the stack, not
// options a caller picks.
export type DialogOptions = Omit<
  ComponentProps<typeof Dialog.Content>,
  'children' | 'overlay' | 'depthFromTop' | 'onExited'
>;

export type DialogService = {
  open: <ReturnType>(
    Component: ComponentType<DialogComponentProps<ReturnType>>,
    options?: DialogOptions,
  ) => Promise<ReturnType | null>;
};

export const DialogContext = createContext<DialogService | null>(null);
